// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__USDvb","text_danger":"TablaProducto_text_danger__u8G9h","text_success":"TablaProducto_text_success__6E7W9"};